import { render, staticRenderFns } from "./Maneno.vue?vue&type=template&id=aca573f0"
import script from "./Maneno.vue?vue&type=script&lang=js"
export * from "./Maneno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports